module.exports = __webpack_public_path__ + "img/notebook-burger.8e555a9e.svg";